export default {
  namespaced: true,
  state: {
    title: {
      init: {
        base: '',
      },
      currentEvent: {
        prefix: new Date(),
        base: '',
        suffix: '',
      },
    },
    selectedFilters: [],
  },
  getters: {
    prefixNavigationTitle: (state) => state.title.currentEvent.prefix,
    mainNavigationTitle: (state) => (state.title.currentEvent.base + state.title.currentEvent.suffix)
      || state.title.init.base,
    currentSelectedFilters: (state) => state.selectedFilters,
  },
  mutations: {
    SET_INIT_NAVIGATION_TITLE_BASE(state, payload) {
      state.title.init.base = payload;
    },
    INIT_CURRENT_NAVIGATION_TITLE_BASE(state, payload) {
      state.title.init.base = payload;
      state.title.currentEvent.base = payload;
    },
    SET_CURRENT_NAVIGATION_TITLE_BASE(state, payload) {
      state.title.currentEvent.base = payload;
    },
    RESET_NAVIGATION_TITLE_BASE(state) {
      state.title.currentEvent.base = state.title.init.base;
    },
    SET_CURRENT_NAVIGATION_TITLE_PREFIX(state, payload) {
      state.title.currentEvent.prefix = payload;
    },
    SET_CURRENT_NAVIGATION_TITLE_SUFFIX(state, payload) {
      state.title.currentEvent.suffix = payload;
    },
    RESET_SELECTED_FILTERS(state) {
      state.selectedFilters = [];
    },
    ADD_SELECTED_FILTER(state, filter) {
      state.selectedFilters.push(filter);
    },
    REMOVE_SELECTED_FILTER(state, filterIndex) {
      state.selectedFilters.splice(filterIndex, 1);
    },
  },
  actions: {
    resetSelectedFilters: ({ commit }) => {
      commit('RESET_SELECTED_FILTERS');
    },
    updateCurrentNavigationTitleSuffix: ({ commit }, titleCurrentEventSuffix) => {
      commit('SET_CURRENT_NAVIGATION_TITLE_SUFFIX', titleCurrentEventSuffix);
    },
    updateCurrentNavigationTitleBase: ({ commit }, baseTitle) => {
      commit('SET_CURRENT_NAVIGATION_TITLE_BASE', baseTitle);
    },
    updateSelectedFilters: ({ state, commit }, filter) => {
      const existingFilterIndex = state.selectedFilters
        .findIndex((selectedFilter) => selectedFilter.property === filter.property
        && selectedFilter.value === filter.value);

      if (existingFilterIndex === -1) { // Filter doesn't exist yet
        commit('ADD_SELECTED_FILTER', filter);
      } else {
        commit('REMOVE_SELECTED_FILTER', existingFilterIndex);
      }
    },
  },
};
